import { GatsbyBrowser } from 'gatsby';
import { initFacebookPixel } from './src/components/facebookPixel';

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
	initFacebookPixel();
};
